
import woman from './pic-collage/woman.jpg';
import womanmap from './pic-collage/woman-map.jpg';
import map from './pic-collage/map2.jpg';
import margarita from './pic-collage/margarita.jpg';
import bosque from './pic-collage/bosque1.jpg';
import bosque2 from './pic-collage/bosque2.jpg';
import pescadores from './pic-collage/pescadores.jpg';
import cowboy from './pic-collage/cowboy.jpg';
import ncowboy from './pic-collage/no-cowboy.jpg';
import godess from './pic-collage/godess.jpg';
import helperbg from './pic-collage/helper-bg.jpg';
import helper from './pic-collage/helper.jpg';
import lionring from './pic-collage/lion-ring.jpg';
import map2 from './pic-collage/map2.jpg';
import ringhelper from './pic-collage/ring-helper.jpg';
import ring from './pic-collage/ring.jpg';
import earrings from './pic-collage/earrings.jpg';
import cliff from './pic-collage/cliff2.jpeg';
import ceibo from './pic-collage/ceibo.jpg';
import king from './pic-collage/king.jpg';
import shore from './pic-collage/rocky-shore2.jpg';
import shore2 from './pic-collage/shore2.jpg';
import cliff2 from './pic-collage/cliff2.jpg';



const Content = [
  { id:0,
    title: '4:00 AM',
    image1: bosque,
    image2: woman,
    copyposition: '  col-md-offset-4 col-md-4 top-5',
    image1position: ' col-md-offset-1 col-md-4',
    image2position: ' col-md-offset-2 col-md-4 top-10',
    copy: 'You’re lying wide awake in a dry forest, after days of wandering around the Ecuadorian coast searching for something to help your brother. ',
    copy2:'You’re running out of ideas but tonight you had a dream about a gold ring. It seems important so you get up and…',
    button1copy:"explore",
    button2copy:"get help",
    choice1:1,
    choice2:2,
  },
    /// Part 01
  { id:1, // Explore
    title: '4:30 AM',
    image1: map,
    image2: pescadores,
    image1position: ' col-md-offset-1 col-md-6 top-5',
    image2position: ' col-md-offset-0 col-md-2 top-1',
    copyposition: '  col-md-offset-6 col-md-4 top-15',
    copy: 'You start running out of the dry forest, past a horseshoe shaped village. You think about the letter your brother received, the one with the words "deportation" on it.',
    copy2:'You reach the sea shore and look out to see a figure slowly emerging from the water.',
    button1copy:"Say hi",
    button2copy:"Hide",
    choice1:3,
    choice2:4,
  },
  { id:2, // Get help
    title: '4:15 AM',
    image1: bosque2,
    image2: cowboy,
    image1position: ' col-md-offset-1 col-md-3 top-20',
    image2position: ' col-md-6 top-0',
    copyposition: '  col-md-offset-2 col-md-4 top-10',
    copy: 'At first only the hummingbirds reply to your call, but a few minutes later, a cowboy appears. You tell him about the letter your brother received, the one with the words "deportation" on it.',
    copy2:'He doesn\'t totally understand, but he motions for you to jump on his horse anyways.',
    button1copy:"Kick him",
    button2copy:"Jump on",
    choice1:5,
    choice2:6,
  },
    /// Part 02
    { id:3, // say hi
      title: '4:45 AM',
      image1: helper,
      image2: earrings,
      image1position: ' col-md-offset-0 col-md-5 top-0',
      image2position: ' col-md-offset-0 col-md-3 top-20',
      copyposition: '  col-md-offset-7 top-0 col-md-4',
      copy: 'You wave them over, and tell them about the abuelita who sent you here, the one at the chicken shop in Queens.',
      copy2:'They nod understandingly, and extend their clay colored hand to reveal a pair of sparkling earrings, “First, take these”. You reach your hand out and...',
      button1copy:"Accept them",
      button2copy:"Knock them down",
      choice1:7,
      choice2:8,
    },
    { id:4, // Hide from caoba
      title: '5:00 AM',
      image1: ceibo,
      image2: earrings,
      image1position: ' col-md-offset-0 col-md-3 top-5',
      image2position: ' col-md-offset-2 col-md-5 top-0',
      copyposition: '  col-md-offset-2 col-md-4 top-10',
      copy: 'You run away from the shore back to the forest. While running, you think about the abuelita in Queens who told you to come here. What was she thinking?',
      copy2:'  Suddenly something on the ground catches your eye. You pause to look down and find a pair of beautiful silver earrings. You...',
      choice1:9,
      choice2:10,
      button1copy:"Pocket them",
      button2copy:"Keep running",
    },
    /// B - Cowboy
    { id:5, // Kick him
      title: '4:30 AM',
      image1: ncowboy,
      image2: womanmap,
      image1position: ' col-md-offset-3 col-md-4 top-10',
      image2position: ' col-md-4 top-10',
      copyposition: '  col-md-offset-1 col-md-4 top-5',
      copy: 'He falls, and in a flash you jump on the horse and ride. You\'re thinking about the abuelita in Queens who told you to come here, when you notice another abuelita waving you down. ',
      copy2:'She\'s in awe of a woman on a horse, and offers you a pair of silver earrings. You gratiously...',
      button1copy: 'Decline',
      button2copy: 'Accept',
      choice1: '11',
      choice2: '12',
    },
    { id:6, // Jump on
      title: '6:00 AM',
      image1: cliff,
      image2: earrings,
      image1position: ' col-md-offset-0 col-md-3 top-20',
      image2position: ' col-md-offset-2 col-md-5 top-5',
      copyposition: '  col-md-offset-2 col-md-4 top-10',
      copy: 'You ride away together. While riding you tell him about the abuelita in Queens who told you to come here, and the ring you hope to find until eventually you reach a cliff. ',
      copy2:'He turns to you timidly, and asks you to stay as his wife in exchange for a pair of silver earrings. You hesitate and then...',
      button1copy: 'Steal the jewels',
      button2copy: 'Reject him',
      choice1: '13',
      choice2: '14',
    },
  ///// Part 03
  { id:7, // Accept them from caoba
    title: '5:30 AM',
    image1: godess,
    image2: cliff,
    image1position: ' col-md-offset-0 col-md-5 top-0',
    image2position: ' col-md-offset-2 col-md-3 top-5"',
    copyposition: '  top-10 col-md-offset-5 col-md-4',
    copy: 'Earrings dangling, you walk past howling fishermen while Caoba holds your hand. You pass a small stumbling child much like your brother\'s daughter.' ,
    copy2:'Eventually, you reach a cliff where Caoba softly asks you to jump with them. Hit with a wave of emotions you...',
    button1copy: 'Jump',
    button2copy: 'Collapse & cry',
    choice1: '15',
    choice2: '17',
  },
  { id:8, // Reject caobas hand...
    title: '6:00 AM',
    image1: cliff2,
    image2: godess,
    image1position: ' col-md-offset-3 col-md-4 top-5',
    image2position: ' pic-item col-md-4 top-10',
    copyposition: '  top-10 col-md-offset-1 col-md-4',
    copy: 'The earrings fall and dissapear along with the figure. Anxious, you run away from the shore past howling fishermen and stumbling children not unlike your brother\'s daughter.',
    copy2:'Eventually, you reach a cliff where you find someone standing on the edge. Overwhelmed with emotions, you...',
    button1copy: 'Collapse & cry',
    button2copy: 'Push them off',
    choice1: '16',
    choice2: '17',
  },
  { id:9, // Take the earrings from the ground
    title: '6:00 AM',
    image1: cliff,
    image2: king,
    image1position: ' col-md-offset-4 col-md-4 top-10',
    image2position: ' col-md-2 col-md-offset-0 top-5',
    copyposition: '  col-md-offset-0  top-0 col-md-4',
    copy: 'Earrings dangling, you wander calmly, passing fishermen and stumbling children who remind you of your brother\'s daughter.  ',
    copy2:'Eventually you hit a cliff, and walk up to the edge. Someone emerges and whispers in your ear: jump with me. Suddenly hit with a wave of emotions, you...',
    button1copy: 'Collapse & cry',
    button2copy: 'Jump',
    choice1: '16',
    choice2: '15',
  },
  { id:10, // keep running don't pick up the earrrings
    title: '6:00 AM',
    image1: king,
    image2: cliff2,
    image1position: ' col-md-offset-3 col-md-4 top-10',
    image2position: ' col-md-4 col-md-offset-0 top-0',
    copyposition: '  col-md-offset-0  top-15 col-md-4',
    copy: 'Suspicious of everything around you, you move quietly. Your thoughts bring you back home to your brother\'s stumbling daughter.',
    copy2:'You walk until you reach a cliff where someone stands near the edge. The signal for you to jump off with them. In a fit of emotions, you…',
    button1copy: 'Collapse & cry',
    button2copy: 'Push them off',
    choice1: '16',
    choice2: '17',
  },
  { id:11,
    title: '6:00 AM',
    image1: cliff,
    image2: godess,
    image1position: ' col-md-offset-1 col-md-3 top-0',
    image2position: ' col-md-offset-2 col-md-5 top-5"',
    copyposition: '  top-10 col-md-offset-3 col-md-4',
    copy: 'She tucks them in your boots anyways and you keep riding. You remember the wooden horse that your brother\'s daughter would rock on. ',
    copy2:'Eventually you reach a cliff and get off the horse. A figure appears beside you, but you\'re too exhaused to care. They signal for you to jump off the cliff with them. You...',
    button1copy: 'Collapse & cry',
    button2copy: 'Jump off',
    choice1: '16',
    choice2: '15',
  },
    { id:12,
      title: '6:00 AM',
      image1: cliff2,
      image2: godess,
      image1position: ' col-md-offset-1 col-md-3 top-0',
      image2position: ' col-md-offset-2 col-md-5 top-5"',
      copyposition: '  top-10 col-md-offset-3 col-md-4',
      copy: 'You continue riding, earrings dangling, until you come to a path blocked by a cliff. You see a figure standing on the edge. They look back at you and signal you to jump.',
      copy2:'In a fit of emotions and urgency you…',
      button1copy: 'Push them off',
      button2copy: 'Jump off',
      choice1: '17',
      choice2: '15',
    },
    { id:13,
      title: '6:00 AM',
      image1: cliff,
      image2: godess,
      image1position: ' col-md-offset-1 col-md-3 top-0',
      image2position: ' col-md-offset-2 col-md-5 top-5"',
      copyposition: '  top-10 col-md-offset-3 col-md-4',
      copy: 'You grab the earrings and rush towards the cliff, unsure of what your plan is. Suddenly a figure appears, and they signal for you to jump over the cliff with them..',
      copy2:'Feeling stuck and overwhelmed you...',
      button1copy: 'Jump off',
      button2copy: 'Push them off',
      choice1: '15',
      choice2: '17',
    },
    { id:14,
      title: '6:00 AM',
      image1: cliff2,
      image2: godess,
      image1position: ' col-md-offset-1 col-md-3 top-0',
      image2position: ' col-md-offset-2 col-md-5 top-5"',
      copyposition: '  top-10 col-md-offset-3 col-md-4',
      copy: 'You jump off the horse and watch him ride away. Confused, you walk towards the cliff to look below. You notice someone at the edge of the cliff, and walk towards them. ',
      copy2:'In a fit of emotions and urgency you…',
      button1copy: 'Collapse & cry',
      button2copy: 'Push them off',
      choice1: '16',
      choice2: '17',
    }, // Part 04
    /// jump off
    { id:15,
      title: '6:15 AM',
      image1: lionring,
      image2: shore,
      image1position: ' col-md-offset-4 col-md-5 top-10',
      image2position: ' col-md-2 top-15',
      copyposition: '  col-md-offset-1 col-md-4',
      copy: 'You prepare for the worst, but soon you\'re floating neatly down to the shore. Once on shore, your partner extends their hand to reveal the ring.',
      copy2:' "Why should I give you the ring?" they ask. You... ',
      button1copy: 'Offer the earrings',
      button2copy: 'Steal the ring',
      choice1: '19',
      choice2: '20',
    }, //begin to weep
    { id:16,
      title: '6:15 AM',
      image1: lionring,
      image2: shore,
      image1position: ' col-md-offset-4 col-md-5 top-10',
      image2position: ' col-md-2 top-15',
      copyposition: '  col-md-offset-1 col-md-4',
      copy: 'With their fingertips they lightly close your eyes. You open them to find yourself at a rocky shore, with the figure standing by you.',
      copy2:'"Why should I give you the ring?" they ask. You... ',
      button1copy: 'Ask kindly',
      button2copy: 'Offer the earrings',
      choice1: '18',
      choice2: '19',
    }, // push her off
    { id:17,
      title: '6:15 AM',
      image1: lionring,
      image2: shore,
      image1position: ' col-md-offset-4 col-md-5 top-10',
      image2position: ' col-md-2 top-15',
      copyposition: '  col-md-offset-1 col-md-4',
      copy: 'You\'re stronger than you thought and you tumble down along with them.You land with a thud, the waves crashing against you.',
      copy2:'The figure stands over you and asks, "Why should I give you the ring?". You...',
      button1copy: 'Steal it',
      button2copy: 'Ask kindly',
      choice1: '20',
      choice2: '18',
    },// Part 05
    //ask kindly
    { id:18,
      title: '6:30 AM - The End',
      image1: ring,
      image2: godess,
      copyposition: '  col-md-offset-4 col-md-4 top-5',
      image1position: ' col-md-offset-0 col-md-5',
      image2position: ' col-md-offset-2 col-md-4 top-10',
      copy: '“Por favor, we need this ring,” you say, but your eyes say much more. They smile softly and hand you the ring.',
      copy2:"As you take the ring, you feel immediately powerful. You'll stay here and rule in Valdivia, your brother already becoming a memory. ",
      button1copy: 'Try again',
      button2copy: 'About',
      choice1: '0',
      link: 'http://www.everywwwhere.net/2018/09/27/making-a-text-adventure-game-valdivia/',
    }, //offer the earrings
    { id:19,
      title: '6:30 AM - The End',
      image1: lionring,
      image2: shore2,
      copyposition: '  col-md-offset-4 col-md-4 top-5',
      image1position: ' col-md-offset-0 col-md-5',
      image2position: ' col-md-offset-2 col-md-4 top-10',
      copy: 'You hold out your hand with the earrings, but they swiftly grab them and jump in to the sea. You watch your earrings and ring swim away.',
      copy2:'Alone on the shore, you have nothing left to help your brother. You have failed.',
      button1copy: 'Try again',
      button2copy: 'About',
      choice1: '0',
      link: 'http://www.everywwwhere.net/2018/09/27/making-a-text-adventure-game-valdivia/',

    }, // try and take it
    { id:20,
      title: '6:30 AM - The End',
      image1: ring,
      image2: shore2,
      copyposition: '  col-md-offset-4 col-md-4 top-5',
      image1position: ' col-md-offset-0 col-md-5',
      image2position: ' col-md-offset-2 col-md-4 top-10',
      copy: 'With unexpected agility you grab the ring and push the figure to the sea. You hold it tightly in your closed fist, the glow peeking through.  ',
      copy2:"You\'ll be able to save your brother and his family. You did it. ",
      button1copy: 'Try again',
      button2copy: 'About',
      choice1: '0',
      link: 'http://www.everywwwhere.net/2018/09/27/making-a-text-adventure-game-valdivia/',


    },
];

export default Content;



// WEBPACK FOOTER //
// ./src/Content.js